import { FC, ReactNode } from 'react';
import { Container } from '@dagensmat/carrot/Layout';
import { FormFieldLabel } from './label';
import { FormFieldOptional } from './optional';
import { FormFieldExplanation } from './explanation';

type Props = {
  label?: string | null;
  optional?: boolean;
  explanation?: ReactNode;
};

export const LabelContainer: FC<Props> = ({ explanation, label, optional }) => {
  if (!label && !optional && !explanation) {
    return null;
  }

  return (
    <Container flex gap="xs" wrap="wrap">
      {label && <FormFieldLabel>{label}</FormFieldLabel>}
      {optional && <FormFieldOptional />}
      <FormFieldExplanation>{explanation}</FormFieldExplanation>
    </Container>
  );
};
